// extracted by mini-css-extract-plugin
export var activeDot = "_80-c";
export var buttonContainer = "_80-9";
export var channelButton = "_80-a";
export var clickable = "_80-d";
export var content = "_80-0";
export var contentFull = "_80-2";
export var contentThird = "_80-1";
export var contentWrapper = "_80-7";
export var description = "_80-5";
export var heightShort = "_80-f";
export var image = "_80-3";
export var imageContainer = "_80-4";
export var selectButton = "_80-e";
export var spinnerContainer = "_80-b";
export var titleContent = "_80-8";
export var titleWrapper = "_80-6";